import React from "react";
import { ApprovalProductCard } from "./approval-product-card";

export function ApprovalGrid({ rows, onViewProduct, onEditProduct }) {
  if (!rows.length) {
    return (
      <p className="my-0 py-12 text-center text-[14px] font-medium text-[#9CA3AF]">
        No products match your filters.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4">
      {rows.map((product) => (
        <ApprovalProductCard
          key={product.id}
          product={product}
          onViewProduct={onViewProduct}
          onEditProduct={onEditProduct}
        />
      ))}
    </div>
  );
}
